<template v-slot:searchAreaHeader>
  <div class="app-main-inner-row extension-conditions-form search-areaheader" style="background: #f5f7f7; padding: 5px 16px 0 16px !important;">
    <el-form inline label-position="left">
      <el-form-item :label="inputDateLabel" class="el-form-item-search">
        <el-row>
          <el-col :span="8">
            <el-form-item label-width="0">
              <el-date-picker
                v-model="searchConditions.inputDateStart"
                type="date"
                no="inputDateStart"
                style="margin-right: 0px;"
                :clearable="false"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                :editable="false"
              /></el-form-item>
          </el-col>
          <el-col :span="2"><span style="margin-left: 5px;">{{ $t('WriteOff.dateTo') }}</span></el-col>
          <el-col :span="8">
            <el-form-item label-width="0">
              <el-date-picker
                v-model="searchConditions.inputDateEnd"
                type="date"
                no="inputDateEnd"
                clearable
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="0">
              <el-checkbox v-model="allowTwoYearOutside" no="allowTwoYearOutside">{{ $t('Invoice.invoice_queryLotsOfData') }}</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'SearchAreaHeader',
  props: {
    pageMode: { type: String, required: true, default: '' }, // tab页面
    searchConditions: { type: Object, required: true }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      allowTwoYearOutside: false
    }
  },
  computed: {
    inputDateLabel() {
      switch (this.pageMode) {
        case 'jobQuery': return this.$t('Invoice.invoice_businessDate')
          break
        case 'invoiceReceivable':
        case 'invoicePayable':
        case 'invoiceReceivablePayable':
        case 'invoicePayableOffset': return this.$t('Invoice.invoice_invoiceDate')
          break
        case 'billingReceivable':
        case 'billingPayable':
        case 'billingOversea': return this.$t('Billing.billingJob_billDate')
          break
        case 'chargeReceipt':
        case 'chargePayment':
        case 'chargeReceiptForegin':
        case 'chargePaymentForegin':
        case 'chargeReceiptPayment':
        case 'chargePrePayment':
        case 'preReceiptPayment':
        case 'preReceiptPaymentClear':
        case 'receiptPaymentOffset': return this.$t('WriteOff.revenueAndExpenditureDate')
          break
        case 'billPaymentQuery': return this.$t('Billing.billingJob_billPaymentDate')
          break
      }
    }
  },
  watch: {
    allowTwoYearOutside(val) {
      if (val) {
        this.$confirm(this.$t('Clearing.SearchingYouSureYouAgo'), this.$t('CargoMsg.Cargo_ConfirmR'), { type: 'warning' }).catch(err => {
          console.log(err)
          this.allowTwoYearOutside = false
        })
      } else {
        this.searchConditions.inputDateStart = moment().subtract(2, 'y').format('yyyy-MM-DD')
      }
    }
  },
  methods: {
    disabledDate(currDate) {
      if (!this.allowTwoYearOutside) {
        const beforeTwoYear = moment().subtract(2, 'y').subtract(1, 'days')
        return currDate < beforeTwoYear
      }
      return false
    }
  }
}
</script>
<style lang="scss">
  .search-areaheader {
    .el-form-item-search {
      margin-right: 15px;
      .el-form-item__label {
        padding-right: 5px;
        font-size: 14px !important;
      }
      .el-form-item__content {
        .el-radio {
          margin-right: 3px;
          .el-radio__label {
            font-size: 13px !important;
            padding-left: 2px;
          }
        }
        .el-checkbox {
          .el-checkbox__label {
            font-size: 13px !important;
            padding-left: 2px;
          }
        }
        .el-date-editor {
          //.el-input__prefix {
          //  display: none;
          //}
        }
        .el-input {
          width: 110px;
        }
        .el-input__inner {
          padding-left: 20px !important;
          padding-right: 5px !important;
          width: 110px;
        }
      }
    }
  }
</style>
